module.exports = __webpack_public_path__ + "static/media/cubes-detail.c1c2e924.jpg";